
import React, { useEffect, useState, useReducer, useRef } from "react";
import { Row, Col, Form, Modal, Accordion, OverlayTrigger, Popover } from "react-bootstrap";
import { FaExchangeAlt, FaChevronDown } from "react-icons/fa";
import { AiFillCopy, AiOutlineCheckCircle, AiOutlinePlus } from "react-icons/ai";
import { BiSortAlt2 } from "react-icons/bi";
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { useMiddletier } from "../common/middletier";
import Loading from './Loading';
// import { useForm } from "react-hook-form";
import { useLocation } from 'react-router-dom';
// import { FaInfoCircle } from "react-icons/fa";
import { TENANT_BUCKET, GAME_MENU_DATA } from '../common/constants';
import { useStoreState, useStoreDispatch, APP_STORE_ACTION } from '../common/storeContext'
import { useNavigate } from "react-router-dom"
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';



const UploadImage = ({ label, onUploaded, uploadFolder }) => {
    const appState = useStoreState()
    const { t, i18n } = useTranslation();
    const [isLoading, setLoading] = useState(false);
    const { queries, mutation, query } = useMiddletier()
    const appDispatch = useStoreDispatch()
    const [files, setFiles] = useState(null);
    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 992px)'
    })

    const handleChange = (newValue) => {
        appDispatch({ type: APP_STORE_ACTION.SET_LOADING, payload: true })

        let checkErrorCode = 0

        const f = newValue.target.files?.[0];
        if (!f) return;

        if (files?.preview) URL.revokeObjectURL(files.preview);

        const preview = URL.createObjectURL(f);
        setFiles({ ...f, preview });

        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        if (!validTypes.includes(f?.type)) {
            newValue.target.value = "";
            return appDispatch({
                type: APP_STORE_ACTION.SHOW_ALERT,
                payload: { description: 'Only JPEG and PNG image formats are supported. Please check your file type and try again.', typeAlert: 'error' }
            });
        } else {
            const isLt8MB = f?.size / 1024 / 1024 < 8;

            if (isLt8MB) {
                let params = [
                    { code: 'folder', value: uploadFolder, graphqlType: 'String', required: false },
                    { code: 'file', value: f, graphqlType: 'Upload', required: true }
                ]
                checkErrorCode = 1
                mutation([
                    {
                        method: 'singleUpload',
                        params,

                    }
                ])
                    .then(({ data }) => {
                        appDispatch({ type: APP_STORE_ACTION.SET_LOADING, payload: false })
                        const imageId = data['singleUpload']?.id
                        onUploaded?.(imageId)
                        newValue.target.value = "";

                    })
                    .catch((error) => {
                        newValue.target.value = "";

                        setFiles([])
                        appDispatch({ type: APP_STORE_ACTION.SET_LOADING, payload: false })
                        console.error(error)
                        if (error?.networkError?.statusCode === 401) {
                            appDispatch({ type: APP_STORE_ACTION.UNAUTHENTICATED })

                        } else {
                            if (error?.networkError) {
                                appDispatch({
                                    type: APP_STORE_ACTION.SHOW_ALERT,
                                    payload: { description: `${error} [${checkErrorCode}-${error?.networkError?.statusCode ?? '0'}]`, typeAlert: 'error' }
                                });
                            }
                            else if (error.graphQLErrors?.length) {
                                const gqlErr = error.graphQLErrors[0]?.gqlErr.extensions?.code;
                                appDispatch({
                                    type: APP_STORE_ACTION.SHOW_ALERT,
                                    payload: { description: `${error} [${checkErrorCode}-${gqlErr ?? 'gpl0'}]`, typeAlert: 'error' }
                                });
                            } else {
                                appDispatch({
                                    type: APP_STORE_ACTION.SHOW_ALERT,
                                    payload: { description: `${error} [${checkErrorCode}]`, typeAlert: 'error' }
                                });
                            }
                        }
                    })
            } else {
                newValue.target.value = "";

                setFiles([])
                alert('failed')
                appDispatch({ type: APP_STORE_ACTION.SET_LOADING, payload: false })

                if (!isLt8MB) {
                    return appDispatch({
                        type: APP_STORE_ACTION.SHOW_ALERT,
                        payload: { description: `Image size must below 8MB [${checkErrorCode}]`, typeAlert: 'error' }
                    });
                }

            }
        }
    }

    useEffect(() => {
        return () => {
            if (files?.preview) URL.revokeObjectURL(files.preview);
        };
    }, [files]);


    return (<>
        <section className={'uploadImageContainer'}>
            <div className={`${files ? ('d-none') : 'beforeUploadImage'}`}>
                <AiOutlinePlus />
                <span>{t('upload')}</span>
            </div>
            <div className="afterUploadImageContainer">
                <div className="afterUploadImage">
                    {files && (
                        <img
                            src={files.preview}
                            key={files.name}
                            alt=""
                        />
                    )
                    }
                </div>
            </div>
            <input type="file" accept="image/png,image/jpeg" onChange={handleChange} multiple={false} />
        </section>
    </>)
}


export default UploadImage;
